export const formatHtmlForEditing = (value = '') => {
  const normalized = value.replace(/>\s*</g, '><').trim();
  let indent = 0;

  return normalized
    .replace(/(<[^>]+>)/g, '\n$1\n')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      if (/^<\//.test(line)) indent = Math.max(indent - 1, 0);
      const formattedLine = `${'  '.repeat(indent)}${line}`;
      if (/^<(?!!|\?|meta|link|img|br|hr|input|source)[^/].*>$/.test(line) && !/<\/[^>]+>$/.test(line)) {
        indent += 1;
      }
      return formattedLine;
    })
    .join('\n');
};
